import * as React from 'react';
import {useMemo} from 'react';
import {Redirect, Route, Switch, useLocation} from 'react-router-dom';

import {AppRouting} from '../../AppConstants';
import {Loading} from '../Loading/Loading';

import styles from './Layout.module.scss';
import {Sidebar} from '../Sidebar/Sidebar';
import {observer} from 'mobx-react';
import {AppStore, AppStoreContext} from '../../Stores/AppStore';
import {ConfirmationDialog} from "../ConfirmationDialog/ConfirmationDialog";
import Tickets from "../Tabs/Tickets";
import TicketDetails from "../Tabs/TicketDetails";
import Tasks from "../Tabs/Tasks";
import TasksDetails from "../Tabs/TasksDetails";
import Logs from "../Tabs/Logs";
import {AnimatePresence} from "framer-motion";
import {AnimatedRoute, AnimateVariant} from "../AnimatedRoute/AnimatedRoute";
import {ServiceFilters} from "../Tabs/ServiceFilters";
import {PopoverDialog} from "../PopoverDialog/PopoverDialog";

export const Layout = observer(() => {
    const appStore = useMemo(() => new AppStore(), []);
    const showGlobalLoader = appStore.globalLoader.isPending || appStore.filtersStore.isLoading.isPending;
    const location = useLocation();
    return (
        <div className={styles.root}>
            <AppStoreContext.Provider value={appStore}>
                <div className={styles.main}>
                    <ServiceFilters/>
                    <AnimatePresence exitBeforeEnter>
                        <Switch location={location} key={location.pathname}>
                            <Route exact path={AppRouting.Tickets}>
                                <AnimatedRoute children={<Tickets/>}/>
                            </Route>
                            <Route path={`${AppRouting.Tickets}/:id`}>
                                <AnimatedRoute variants={AnimateVariant.bottom} children={<TicketDetails/>}/>
                            </Route>
                            <Route exact path={AppRouting.Tasks}>
                                <AnimatedRoute children={<Tasks/>}/>
                            </Route>
                            <Route path={`${AppRouting.Tasks}/:id`}>
                                <AnimatedRoute variants={AnimateVariant.bottom} children={<TasksDetails/>}/>
                            </Route>
                            <Route path={AppRouting.Logs}>
                                <AnimatedRoute children={<Logs/>}/>
                            </Route>
                            <Redirect from="*" to={AppRouting.Tickets}/>
                        </Switch>
                    </AnimatePresence>
                    <PopoverDialog/>
                </div>
                <Sidebar/>
                <ConfirmationDialog/>
                <Loading loading={showGlobalLoader}/>
            </AppStoreContext.Provider>
        </div>
    );
});

